<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Cadastrar Produtor" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-producer :producer="producer" @submit="($model: Producer) => submit($model)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormProducer from '@/views/producers/form-producer.vue'
import ProducerService from '@/services/ProducerService'
import type Producer from '@/types/Producer'

export default defineComponent({
  components: {
    TPageTitle,
    FormProducer,
  },
  emits: [ 'submit' ],
  data() {
    return {
      producer: {
        data: {
          cellphone: '',
          company_name: '',
          display_name: '',
          tax_id: '',
          trade_name: '',
          ticket_advantages_url: '',
          ticket_prefix: '',
          website_url: '',
          club_id: '',
          logo: undefined as File | undefined,
          address: {
            city: '',
            number: '',
            neighborhood: '',
            state: '',
            street: '',
            zipcode: '',
            complement: '',
          },
        },
        additional: {
          administrative: {
            cellphone: '',
            email: '',
            name: '',
          },
          financial: {
            cellphone: '',
            email: '',
            name: '',
          },
          social: {
            facebook_url: '',
            twitter_url: '',
            instagram_url: '',
          },
        },
      } as Producer,
    }
  },
  methods: {
    async submit(model: Producer) {
      try {
        this.$loader.increment()
        await (new ProducerService()).store(model)

        this.$snackbar.show(
          'Produtor criado com sucesso',
          'success',
        )

        // this.$router.push({ name: "manage-producer" })
      } finally {
        this.$loader.decrement()
      }
    },
  },
})
</script>
